import { RootState } from "@/app/stores";
import { getCampaigns, getChannels } from "@/shared/api/marketing-campaigns";
import { IChannel, IListMarketingCampaignResults } from "@/shared/api/marketing-campaigns";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchCampaigns = createAsyncThunk<
    IListMarketingCampaignResults,
    void,
    { state: RootState }
>(`marketingCampaigns/fetchCampaigns`, async (_, thunkAPI) => {
    try {
        const { limit, page, search } = thunkAPI.getState().marketingCampaigns
        const data = await getCampaigns(page, limit, search)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchChannels = createAsyncThunk<
    IChannel[],
    void,
    { state: RootState }
>(`marketingCampaigns/fetchChannels`, async (_, thunkAPI) => {
    try {
        const data = await getChannels()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})